
import { MapLocation } from '@/types/location';

// Monster Cage Gym Locations
export const monsterCageGyms: MapLocation[] = [
  {
    id: 36001,
    name: "Monster Cage - Jeddah (Rabwa)",
    type: "Gym",
    devices: 4,
    coordinates: [21.6164623300209, 39.17135943558233],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
